module.exports = __webpack_public_path__ + "assets/img/media_8.a3162837.png";